export function CustomModalChartTick(props: any) {
  const { x, y, tickFormatter, payload, index, visibleTicksCount, isEmpty } =
    props;

  const date = tickFormatter(payload.value);
  const splittedDate = date.split(",");

  const tickToShow: any[] = [];

  const isVisible = (splitIndex: number) => {
    if (index === 0 || index === visibleTicksCount - 2) {
      return true;
    }

    if (splitIndex === 1) {
      return true;
    }

    return false;
  };

  splittedDate.forEach((value: string, splitIndex: number) => {
    tickToShow.push(
      <tspan
        textAnchor="middle"
        x="0"
        dy={`${0.71 + 0.71 * splitIndex}em`}
        key={`${date.toString()}-${splitIndex}`}
        opacity={isVisible(splitIndex) ? 1 : 0}
      >
        {value}
      </tspan>
    );
  });

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        fill={isEmpty ? "#B5B5B6" : "#727272"}
        fontSize="12px"
        fontWeight="400"
      >
        {tickToShow}
      </text>
    </g>
  );
}
